import React, { useCallback, useEffect, useState } from "react";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../firebase";
import { ClubEvent, Player } from "../types";
import { EventsTab } from "../views/AdminView";

/**
 * Järjestäjän välilehti pelaajanäkymässä (docs/roolit.md).
 *
 * Samat tapahtumakortit kuin ylläpidossa, järjestäjätilassa: kutsut,
 * ottelujen arvonta ja lisäys, tulokset, paikalla-merkintä ja illan
 * päättäminen. Tapahtumien luonti ja muokkaus, poistot ja DUPR-lähetys
 * ovat piilossa — ja Firestore-säännöt estävät ne joka tapauksessa.
 *
 * Järjestäjä on kentän laidalla puhelin kädessä, joten tämä elää
 * pelaajanäkymän rinnalla eikä erillisessä ylläpitonäkymässä.
 */
export default function OrganizerTab({ clubId, lang }: { clubId: string; lang: "fi" | "en" }) {
  const [events, setEvents]   = useState<ClubEvent[]>([]);
  const [players, setPlayers] = useState<Player[]>([]);

  const loadEvents = useCallback(async () => {
    const snap = await getDocs(
      query(collection(db, "clubs", clubId, "events"), orderBy("createdAt", "desc"))
    );
    setEvents(snap.docs.map(d => ({ id: d.id, ...d.data() } as ClubEvent)));
  }, [clubId]);

  useEffect(() => {
    loadEvents().catch(err => console.error("OrganizerTab: tapahtumat", err));
    getDocs(query(collection(db, "clubs", clubId, "players"), orderBy("name")))
      .then(snap => setPlayers(snap.docs.map(d => ({ id: d.id, ...d.data() } as Player))))
      .catch(err => console.error("OrganizerTab: pelaajat", err));
  }, [clubId, loadEvents]);

  return (
    <EventsTab clubId={clubId} events={events} players={players}
      onRefresh={loadEvents} lang={lang} organizer />
  );
}
